import { styled } from '@/stitches/index.js';

export const HorizontalDivider = styled('div', {
  backgroundColor: '$defaultFont',
  // eslint-disable-next-line @contra/enforce-stitches-tokens
  height: '2px',
  margin: '$12 0',
  width: '100%',
});
